export const add = (a, b) => ({
    x: a.x + b.x,
    y: a.y + b.y,
});
export const subtract = (a, b) => ({
    x: a.x - b.x,
    y: a.y - b.y,
});
export const scale = (value, factor) => ({
    x: value.x * factor,
    y: value.y * factor,
});
export const dot = (a, b) => a.x * b.x + a.y * b.y;
export const lengthSquared = (value) => dot(value, value);
export const length = (value) => Math.sqrt(lengthSquared(value));
export function normalize(value, fallback = { x: 1, y: 0 }) {
    const magnitude = length(value);
    if (magnitude <= Number.EPSILON)
        return { ...fallback };
    return scale(value, 1 / magnitude);
}
export function clamp(value, minimum, maximum) {
    return Math.min(maximum, Math.max(minimum, value));
}
export function clampMagnitude(value, maximum) {
    const magnitudeSquared = lengthSquared(value);
    if (magnitudeSquared <= maximum * maximum)
        return { ...value };
    return scale(value, maximum / Math.sqrt(magnitudeSquared));
}
export function deterministicRound(value, precision) {
    if (!Number.isFinite(value))
        throw new RangeError("Simulation produced a non-finite value");
    const rounded = Math.round(value / precision) * precision;
    return Object.is(rounded, -0) ? 0 : rounded;
}
export function roundVector(value, precision) {
    return {
        x: deterministicRound(value.x, precision),
        y: deterministicRound(value.y, precision),
    };
}
export function oppositePlayer(player) {
    return player === "PLAYER_A" ? "PLAYER_B" : "PLAYER_A";
}
//# sourceMappingURL=math.js.map